





























































































































import { Component, Prop, Ref, Vue, Watch, PropSync } from 'vue-property-decorator';
import CardTitle from '@/components/common/CardTitle.vue';
import BarChart from '@/components/chart/BarChart.vue';
import RadialBarChart from '@/components/chart/RadialBarChart.vue';
import { CHART_TYPES, CHART_TYPE_NAMES } from '@/utils/ChartTypes';
import { VIEWPOINT_API } from '@/api/ViewpointApi';
import Modelling from '@/store/modules/Modelling';
import ScoringKeys from "@/store/modules/ScoringKeys";
import { getModule } from 'vuex-module-decorators';
import Decisions from '@/store/modules/Decisions';
import Viewpoints from '@/store/modules/Viewpoints';
import WorkspaceOptions from '@/store/modules/WorkspaceOptions';
import Choices from '@/store/modules/Choices';
import Scoring from '@/store/modules/Scoring';


const scoringKeysModule = getModule(ScoringKeys);
const workspaceOptions = getModule(WorkspaceOptions);
const modellingModule = getModule(Modelling);
const decisionsModule = getModule(Decisions);
const viewpointModule = getModule(Viewpoints);
const choicesModule = getModule(Choices);

@Component({
    name: 'ViewpointScorerChart',
    components: {
        RadialBarChart,
        BarChart,
        CardTitle,
    },
})
export default class ViewpointScorerChart extends Vue {
    @Prop({ default: '', type: String })
    factorId!: string;

    private items = CHART_TYPES;
    private CHART_TYPE_NAMES = CHART_TYPE_NAMES;
    private isLoading = false;
    private open = false;
    private tooltipShow = false;
    private task: any;

    private chartData = {
        data: {
            series: [],
        },
        title: '',
        xaxis: {
            categories: [],
        },
    };

    private radial = {
        data: {
            series:[],
        },
        title: {
            text: '',
        },
       labels: [],
    };
    get viewpointScoringKeyDefinitions() {
        console.log("viewpointfactorclasschart scoure chart")
        return scoringKeysModule.viewpointScoringKeyDefinitions;
    }

     get chartTitle(){
        console.log("chart title is:",this.chartData.title)
        return this.chartData.title;
    }
    private cancelTask() {
        clearTimeout(this.task);
    }

    private chartDataDelay() {
        this.task = setTimeout(() => {this.getChartData() }, 800);
    }

    get barChartData() {
        console.log("Data to show")
        console.log(this.chartData)
        return this.chartData;
    }

    get radialBarChartData(){
        console.log("Data to show for radial")
        console.log(this.radial)
        return this.radial;
    }

    get factors() {
        return modellingModule.publishedModelFactorResources;
    }

    get decisionId() {
        return decisionsModule.selectedDecisionId;
    }

    get activeViewpointId() {
        return viewpointModule.activeViewpointId;
    }

    get selectedViewpointIds() {
        return viewpointModule.selectedViewpointIds;
    }

    get viewpoints() {
        return viewpointModule.unfilteredViewpointsMap;
    }
    get activeChoiceId() {
        return choicesModule.selectedChoiceId;
    }

    get isViewpointBarChartHorizontal() {
        return workspaceOptions.isViewpointBarChartHorizontal;
    }

    set isViewpointBarChartHorizontal(isHorizontal: boolean) {
        workspaceOptions.setIsViewpointBarChartHorizontal(isHorizontal);
    }

    private async getChartData() {
        try {
            if (this.factorId !== '') {
                this.isLoading = true;
                const scoreskeys = this.viewpointScoringKeyDefinitions
                const factor = this.factors[this.factorId];
                const res = await getModule(Scoring).getStackedBarChartDataVPtab({ decisionId:this.decisionId, viewpointIds:this.selectedViewpointIds, factorIds:factor.childrenIds, factorParentId:factor.id, choiceId: choicesModule.selectedChoice.id}); 
                const classes = await getModule(Scoring).getRadialBarChartDataVPtab({scoreskeys:scoreskeys, decisionId:this.decisionId, viewpointIds:this.selectedViewpointIds, factorIds:factor.childrenIds, factorParentId:factor.id, choiceId: choicesModule.selectedChoice.id}); 
                if (Object.keys(res).length > 0) {
                    this.chartData = res  //[this.activeViewpointId]
                    //this.chartData =  this.transferToChartDataDisplay(res);
                    this.chartData.title = factor.name;
        
                }
                this.isLoading = false;
            }
        } catch (error) {
            console.log(error);
        }
    }
    private transferToChartDataDisplay(res: any) {
        let chartData = {
            data: {
                series: [],
            },
            title: '',
            xaxis: {
                categories: [],
            },
        };
        let firstElem = 0;
        for (let key in res) {
            console.log("KEY in res", key)
            let i = 0;
            if (res[key].data && res[key].data.series.length > 0) {
                res[key].data.series.forEach((item: any) => {
                    if (firstElem === 0) {
                        chartData.data.series.push(item);
                    } else {
                        chartData.data.series[i].data.push(item.data[0]);
                    }
                    i++;
                });
            }
            firstElem++;
            console.log(this.viewpoints, "and key", this.viewpoints[key])
            console.log("why are x-axis categories not working", this.viewpoints[key].name)
            chartData.xaxis.categories.push(this.viewpoints[key].name);
        }
        return chartData;
    }
}
